import { Link } from "react-router-dom";

export const PageHeader = ({ eyebrow, title, intro }) => (
  <section className="bg-[#0B0A08] text-[#F7F4ED]" data-testid="page-header">
    <div className="container-page py-20 md:py-28">
      {eyebrow && <p className="eyebrow fade-up">{eyebrow}</p>}
      <h1 className="fade-up mt-4 max-w-3xl font-serif text-4xl leading-[1.05] tracking-tight sm:text-5xl lg:text-6xl">
        {title}
      </h1>
      {intro && (
        <p className="fade-up mt-6 max-w-2xl text-lg leading-relaxed text-[#F7F4ED]/70">{intro}</p>
      )}
    </div>
  </section>
);

export const Section = ({ children, className = "" }) => (
  <section className={`container-page py-16 md:py-24 ${className}`}>{children}</section>
);

export const CTABanner = ({
  title = "Ready to find the right nanny for your family?",
  body = "Share your needs and the team will review your request personally.",
}) => (
  <section className="bg-[#0B0A08] text-[#F7F4ED]" data-testid="cta-banner">
    <div className="container-page py-16 md:py-20">
      <div className="flex flex-col items-start justify-between gap-8 md:flex-row md:items-center">
        <div className="max-w-2xl">
          <h2 className="font-serif text-3xl tracking-tight sm:text-4xl">{title}</h2>
          <p className="mt-3 text-[#F7F4ED]/70">{body}</p>
        </div>
        <div className="flex flex-col gap-3 sm:flex-row">
          <Link
            to="/request-a-nanny-match"
            data-testid="cta-request-match"
            className="inline-flex items-center justify-center rounded-full bg-[#C6A04A] px-7 py-3.5 text-sm font-semibold text-[#0B0A08] transition-transform hover:scale-[1.02]"
          >
            Request a Nanny Match
          </Link>
          <Link
            to="/for-nannies"
            data-testid="cta-for-nannies"
            className="inline-flex items-center justify-center rounded-full border border-[#F7F4ED]/30 px-7 py-3.5 text-sm font-semibold text-[#F7F4ED] transition-colors hover:border-[#C6A04A] hover:text-[#C6A04A]"
          >
            Apply as a Nanny
          </Link>
        </div>
      </div>
    </div>
  </section>
);
